/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */
export type ChirpVoid = {};

export type AbortMultipartDocumentUploadRequest = {
  documentId: number;
  uploadId: string;
};

export type CompleteMultipartDocumentUploadRequest = {
  documentId: number;
  uploadId: string;
  parts: Default<CompletedMultipartUploadPart[]>;
};

export type CompletedMultipartUploadPart = { partNumber: number; eTag: string };

export type Document = {
  id: number;
  name: string;
  description?: string;
  originalFileName: string;
  contentType: string;
  fileSizeBytes: number;
  status: ProcessingStep;
  originalFileUrl: string;
  processedFileUrl?: string;
  pages: Default<Page[]>;
  portalId: number;
  createdBy: number;
  createdAt: number;
  updatedAt: number;
  deletedAt?: number;
  purgedAt?: number;
  virusScanResult?: VirusScanResult;
  folderId?: number;
  brandId?: number;
};

export type DocumentPresignedDownloadUrl = { downloadUrl: string };

export type DocumentView = {
  id: number;
  title: string;
  originalFileName: string;
  fileSizeBytes: number;
  originalFileUrl: string;
  pdfLink?: string;
  pages: Default<Page[]>;
  portalId: number;
  userId: number;
  createdAt: number;
  updatedAt: number;
  folderId?: number;
  brandId?: number;
  isProcessing: boolean;
  processingOutcome: string;
};

export type GetDocumentRequest = { documentId: number };

export type GetProgressRequest = { documentId: number };

export type ImportDocumentRequest = {
  source: ImportSource;
  sourceUrl?: string;
  accessToken?: string;
  fileManagerFileId?: number;
  folderId?: number;
  title: string;
  documentId?: number;
  description?: string;
  originalFileName: string;
  brandId?: number;
};

export type ImportDocumentResponse = {
  documentId: number;
  currentStep: ProcessingStep;
  percentComplete: number;
};

export type ImportSource =
  | 'S3'
  | 'DRIVE'
  | 'DROPBOX'
  | 'BOX'
  | 'FILE_MANAGER'
  | unhandledEnumCase;

export type InitiateMultipartDocumentUploadResponse = {
  documentId: number;
  uploadId: string;
  partSizeBytes: number;
  parts: Default<MultipartUploadPart[]>;
};

export type MultipartUploadPart = {
  partNumber: number;
  presignedUploadUrl: string;
};

export type Page = {
  id: number;
  pageNumber: number;
  title?: string;
  notes?: string;
  text?: string;
  thumbnailUrl: string;
  imageUrl: string;
  mobileImageUrl?: string;
  largeImageUrl?: string;
};

export type ProcessingStep =
  | 'IMPORTING'
  | 'UPLOADING'
  | 'UPLOAD_DETECTED'
  | 'VIRUS_SCANNING'
  | 'PROCESSING_DOCUMENT'
  | 'PROCESSING_FAILED'
  | 'GENERATING_THUMBNAILS'
  | 'COMPLETED'
  | 'ERROR'
  | unhandledEnumCase;

export type UpdateDocumentRequest = { documentId: number; title: string };

export type UploadDocumentRequest = {
  name: string;
  contentType: string;
  fileSizeBytes: number;
  folderId?: number;
  documentId?: number;
  description?: string;
  originalFileName: string;
  brandId?: number;
};

export type UploadDocumentResponse = {
  documentId: number;
  presignedUploadUrl: string;
};

export type UploadProgress = {
  documentId: number;
  currentStep: ProcessingStep;
  percentComplete: number;
  completedSteps: Default<ProcessingStep[]>;
  errorMessage?: string;
  createdAt: number;
  updatedAt: number;
};

export type VirusScanResult = {
  status: VirusScanStatus;
  detectedVirusNames: Default<string[]>;
  errorMessage?: string;
  message: Default<string>;
};

export type VirusScanStatus =
  | 'CLEAN'
  | 'INFECTED'
  | 'ERROR'
  | unhandledEnumCase;

export type BulkDocumentDeleteRequest = { documentIds: Default<number[]> };

export type BulkDocumentFolderMoveRequest = {
  destinationFolderId?: number;
  documentIds: Default<number[]>;
};

export type BulkDocumentFolderMoveResponse = { documents: Default<Document[]> };

export type BulkUpdateBrandRequest = {
  documentIds: Default<number[]>;
  brandId: number;
};

export type DeleteDocumentRequest = { documentId: number };

export type ShareDocumentRequest = {
  documentId: number;
  name: string;
  expireAt?: number;
  sharedWithViewerId?: number;
  sharedWithEmail?: string;
  hasDownload?: boolean;
  skipForm?: boolean;
};

export type UpdateBrandRequest = { documentId: number; brandId: number };

export type DocumentError = {
  reason: DocumentFailureReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DocumentImportError = {
  errorType: ComHubspotSalesDocumentsModelsErrorAbstractDocumentImportError.ErrorType;
  message: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DocumentUploadError = {
  errorType: ComHubspotSalesDocumentsModelsErrorAbstractDocumentUploadError.ErrorType;
  message: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export namespace ComHubspotSalesDocumentsModelsErrorAbstractDocumentImportError {
  export type ErrorType =
    | 'INVALID_SOURCE'
    | 'MISSING_ACCESS_TOKEN'
    | 'MISSING_FILE_MANAGER_ID'
    | 'MISSING_SOURCE_URL'
    | 'FILE_TOO_LARGE'
    | 'DOWNLOAD_FAILED'
    | 'INVALID_FILE_TYPE'
    | 'INVALID_REQUEST'
    | unhandledEnumCase;
}

export namespace ComHubspotSalesDocumentsModelsErrorAbstractDocumentUploadError {
  export type ErrorType =
    | 'FILE_SIZE_LIMIT_EXCEEDED'
    | 'INVALID_FILE_TYPE'
    | 'INVALID_REQUEST'
    | unhandledEnumCase;
}

export type DocumentFailureReason =
  | 'DOCUMENT_NOT_FOUND'
  | 'ACCESS_DENIED'
  | 'INVALID_EMAIL'
  | 'CONTACT_CREATION_FAILED'
  | 'SHARED_LINK_CREATION_FAILED'
  | 'INTERNAL_ERROR_PERMISSIONS_CLIENT'
  | 'S3_ERROR'
  | 'FOLDER_NOT_FOUND'
  | 'INVALID_REQUEST'
  | 'PDF_NOT_READY'
  | 'PDF_CONVERSION_FAILED'
  | 'BRAND_UPDATE_FAILED'
  | unhandledEnumCase;

export type SharedLinkView = {
  id: number;
  portalId: number;
  userId: number;
  name: string;
  documentId: number;
  accessId: string;
  shortLink?: string;
  url?: string;
  createdAt: number;
  startedAt?: number;
  finishedAt?: number;
  sharedWithViewerId?: number;
  hasDownload: boolean;
  skipForm: boolean;
  expireAt: number;
  pages: Default<Page[]>;
  user?: UserView;
};

export type DocumentUsageView = {
  limit: number;
  userLimit: number;
  currentUsage: number;
};

export type UserView = { firstName?: string; lastName?: string; email: string };

export type UploadDocumentRequestType = Requestify<UploadDocumentRequest>;
export type UploadDocumentResponseType = UploadDocumentResponse;
export type UploadDocumentErrorType = DocumentUploadError & HubspotMetadata;
export const uploadDocumentRpc: ChirpAvroRpcDetails<
  UploadDocumentRequestType,
  UploadDocumentResponseType,
  UploadDocumentErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'uploadDocument',
  auth: 'app',
  fingerprint: 'cZVyXvs5t1wKBDFE3ZxLZsfEoM5ykBrs',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type InitiateMultipartDocumentUploadRequestType =
  Requestify<UploadDocumentRequest>;
export type InitiateMultipartDocumentUploadResponseType =
  InitiateMultipartDocumentUploadResponse;
export type InitiateMultipartDocumentUploadErrorType = DocumentUploadError &
  HubspotMetadata;
export const initiateMultipartDocumentUploadRpc: ChirpAvroRpcDetails<
  InitiateMultipartDocumentUploadRequestType,
  InitiateMultipartDocumentUploadResponseType,
  InitiateMultipartDocumentUploadErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'initiateMultipartDocumentUpload',
  auth: 'app',
  fingerprint: 'cZVyXvs5t1yHXJgihAouJ8fEoM5ykBrs',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CompleteMultipartDocumentUploadRequestType =
  Requestify<CompleteMultipartDocumentUploadRequest>;
export type CompleteMultipartDocumentUploadResponseType = ChirpVoid;
export type CompleteMultipartDocumentUploadErrorType = DocumentUploadError &
  HubspotMetadata;
export const completeMultipartDocumentUploadRpc: ChirpAvroRpcDetails<
  CompleteMultipartDocumentUploadRequestType,
  CompleteMultipartDocumentUploadResponseType,
  CompleteMultipartDocumentUploadErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'completeMultipartDocumentUpload',
  auth: 'app',
  fingerprint: 'n6Ros49tc5SOUe2e_r4XmcfEoM5ykBrs',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type AbortMultipartDocumentUploadRequestType =
  Requestify<AbortMultipartDocumentUploadRequest>;
export type AbortMultipartDocumentUploadResponseType = ChirpVoid;
export type AbortMultipartDocumentUploadErrorType = DocumentUploadError &
  HubspotMetadata;
export const abortMultipartDocumentUploadRpc: ChirpAvroRpcDetails<
  AbortMultipartDocumentUploadRequestType,
  AbortMultipartDocumentUploadResponseType,
  AbortMultipartDocumentUploadErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'abortMultipartDocumentUpload',
  auth: 'app',
  fingerprint: 'gRqNVE6ohdyOUe2e_r4XmcfEoM5ykBrs',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ImportDocumentRequestType = Requestify<ImportDocumentRequest>;
export type ImportDocumentResponseType = ImportDocumentResponse;
export type ImportDocumentErrorType = DocumentImportError & HubspotMetadata;
export const importDocumentRpc: ChirpAvroRpcDetails<
  ImportDocumentRequestType,
  ImportDocumentResponseType,
  ImportDocumentErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'importDocument',
  auth: 'app',
  fingerprint: '0vsdbvi18TtxM9CA99W2e8DFUui7NTaI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetDocumentRequestType = Requestify<GetDocumentRequest>;
export type GetDocumentResponseType = DocumentView;
export type GetDocumentErrorType = EmptyError & HubspotMetadata;
export const getDocumentRpc: ChirpAvroRpcDetails<
  GetDocumentRequestType,
  GetDocumentResponseType,
  GetDocumentErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getDocument',
  auth: 'app',
  fingerprint: 'mjfnwTdgYOREzOgx17KSaJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateDocumentRequestType = Requestify<UpdateDocumentRequest>;
export type UpdateDocumentResponseType = DocumentView;
export type UpdateDocumentErrorType = DocumentError & HubspotMetadata;
export const updateDocumentRpc: ChirpAvroRpcDetails<
  UpdateDocumentRequestType,
  UpdateDocumentResponseType,
  UpdateDocumentErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'updateDocument',
  auth: 'app',
  fingerprint: 'w6Pe8Q0uv11EzOgx17KSaCZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteDocumentRequestType = Requestify<DeleteDocumentRequest>;
export type DeleteDocumentResponseType = ChirpVoid;
export type DeleteDocumentErrorType = DocumentError & HubspotMetadata;
export const deleteDocumentRpc: ChirpAvroRpcDetails<
  DeleteDocumentRequestType,
  DeleteDocumentResponseType,
  DeleteDocumentErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'deleteDocument',
  auth: 'app',
  fingerprint: '1fwnhKH-eQmOUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUploadProgressRequestType = Requestify<GetProgressRequest>;
export type GetUploadProgressResponseType = UploadProgress;
export type GetUploadProgressErrorType = DocumentError & HubspotMetadata;
export const getUploadProgressRpc: ChirpAvroRpcDetails<
  GetUploadProgressRequestType,
  GetUploadProgressResponseType,
  GetUploadProgressErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getUploadProgress',
  auth: 'app',
  fingerprint: 'aCRaUXKTx8AE8UA5VQQqJCZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetDocumentUsageResponseType = DocumentUsageView;
export type GetDocumentUsageErrorType = EmptyError & HubspotMetadata;
export const getDocumentUsageRpc: ChirpAvroRpcDetails<
  undefined,
  GetDocumentUsageResponseType,
  GetDocumentUsageErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getDocumentUsage',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABM7sVFmXbvTpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetDocumentDownloadUrlRequestType = Requestify<GetDocumentRequest>;
export type GetDocumentDownloadUrlResponseType = DocumentPresignedDownloadUrl;
export type GetDocumentDownloadUrlErrorType = DocumentError & HubspotMetadata;
export const getDocumentDownloadUrlRpc: ChirpAvroRpcDetails<
  GetDocumentDownloadUrlRequestType,
  GetDocumentDownloadUrlResponseType,
  GetDocumentDownloadUrlErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getDocumentDownloadUrl',
  auth: 'app',
  fingerprint: 'mjfnwTdgYOSJfDg5qJEAAiZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetDocumentPdfDownloadUrlRequestType =
  Requestify<GetDocumentRequest>;
export type GetDocumentPdfDownloadUrlResponseType =
  DocumentPresignedDownloadUrl;
export type GetDocumentPdfDownloadUrlErrorType = DocumentError &
  HubspotMetadata;
export const getDocumentPdfDownloadUrlRpc: ChirpAvroRpcDetails<
  GetDocumentPdfDownloadUrlRequestType,
  GetDocumentPdfDownloadUrlResponseType,
  GetDocumentPdfDownloadUrlErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getDocumentPdfDownloadUrl',
  auth: 'app',
  fingerprint: 'mjfnwTdgYOSJfDg5qJEAAiZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ShareDocumentRequestType = Requestify<ShareDocumentRequest>;
export type ShareDocumentResponseType = SharedLinkView;
export type ShareDocumentErrorType = DocumentError & HubspotMetadata;
export const shareDocumentRpc: ChirpAvroRpcDetails<
  ShareDocumentRequestType,
  ShareDocumentResponseType,
  ShareDocumentErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'shareDocument',
  auth: 'app',
  fingerprint: 'twWAPz8CoIG95rF2c6lhdSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type MoveDocumentsRequestType =
  Requestify<BulkDocumentFolderMoveRequest>;
export type MoveDocumentsResponseType = BulkDocumentFolderMoveResponse;
export type MoveDocumentsErrorType = DocumentError & HubspotMetadata;
export const moveDocumentsRpc: ChirpAvroRpcDetails<
  MoveDocumentsRequestType,
  MoveDocumentsResponseType,
  MoveDocumentsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'moveDocuments',
  auth: 'app',
  fingerprint: 'AYTE_uy87npOeXAB-1NmmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type BatchDeleteDocumentsRequestType =
  Requestify<BulkDocumentDeleteRequest>;
export type BatchDeleteDocumentsResponseType = ChirpVoid;
export type BatchDeleteDocumentsErrorType = DocumentError & HubspotMetadata;
export const batchDeleteDocumentsRpc: ChirpAvroRpcDetails<
  BatchDeleteDocumentsRequestType,
  BatchDeleteDocumentsResponseType,
  BatchDeleteDocumentsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'batchDeleteDocuments',
  auth: 'app',
  fingerprint: 'If7V9r8XdzKOUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateDocumentBrandRequestType = Requestify<UpdateBrandRequest>;
export type UpdateDocumentBrandResponseType = ChirpVoid;
export type UpdateDocumentBrandErrorType = DocumentError & HubspotMetadata;
export const updateDocumentBrandRpc: ChirpAvroRpcDetails<
  UpdateDocumentBrandRequestType,
  UpdateDocumentBrandResponseType,
  UpdateDocumentBrandErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'updateDocumentBrand',
  auth: 'app',
  fingerprint: 'arKrFmY98g2OUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type BatchUpdateDocumentBrandRequestType =
  Requestify<BulkUpdateBrandRequest>;
export type BatchUpdateDocumentBrandResponseType = ChirpVoid;
export type BatchUpdateDocumentBrandErrorType = DocumentError & HubspotMetadata;
export const batchUpdateDocumentBrandRpc: ChirpAvroRpcDetails<
  BatchUpdateDocumentBrandRequestType,
  BatchUpdateDocumentBrandResponseType,
  BatchUpdateDocumentBrandErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'batchUpdateDocumentBrand',
  auth: 'app',
  fingerprint: 'o751f9p1PIaOUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
